import React, {useState, useEffect} from "react"
import PropTypes from "prop-types"

// config
import Config from "../../../../config"

// components
import Features from "./Features"

// the component
function Benefits({activityVariant, showInlineHelp, hideTitle}) {
  // state
  const [items, setItems] = useState([])

  // side effects
  useEffect(() => {
    // get items
    let wnsItems = activityVariant.benefits.map(b => {
      return {
        key:b._id, 
        text:b["de"],
        info:b.info // TODO use this to display inline help
      }
    })

    // add the default benefits
    Config.standardBenefits.forEach(b => wnsItems.push(b))
    
    // update the state
    setItems(wnsItems)
  }, [activityVariant])

  // render
  if(items.length === 0) {
    return null
  }
  else {
    return (
      <Features 
        title="Leistungen" 
        hideTitle={hideTitle}
        items={items}
        showInlineHelp={showInlineHelp}
      />
    )
  }
}


Benefits.propTypes = {
  showInlineHelp:PropTypes.bool
}
Benefits.defaultProps = {
  showInlineHelp:true
}

export default Benefits

